import {
  Box,
  SkeletonGroup,
  SkeletonLine,
  SkeletonRectangle,
} from '@wix/design-system';

import css from './index.module.scss';

export const SkeletonLoading = () => (
    <SkeletonGroup>
      <Box direction="vertical" gap="20px">
        <SkeletonRectangle className={css.header} />
        <Box direction="vertical" gap="3" className={css.searchResults}>
          {[...Array(3)].map((_, index) => (
            <Box direction="vertical" key={index} gap="4">
              <Box direction="vertical">
                <Box>
                  <SkeletonRectangle className={css.articleTag} />
                </Box>
                <Box direction="vertical" gap="13px">
                  <Box direction="vertical" gap="2">
                    <SkeletonLine className={css.articleTitle} />
                  </Box>
                  <Box verticalAlign="middle">
                    <Box direction="vertical" gap="2" width="100%">
                      <Box verticalAlign="middle" gap="7">
                        <Box direction="vertical" gap="2" width="100%">
                          <SkeletonLine className={css.descriptionFirst} />
                          <SkeletonLine className={css.descriptionSecond} />
                        </Box>
                        <Box>
                          <SkeletonRectangle className={css.timeToRead} />
                        </Box>
                      </Box>
                      <Box verticalAlign="middle" gap="11px">
                        <SkeletonRectangle className={css.category} />
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              {index < 2 && <SkeletonRectangle className={css.separator} />}
            </Box>
          ))}
        </Box>
      </Box>
    </SkeletonGroup>
  );
